module.exports = __webpack_public_path__ + "static/media/user-image.14a6ed2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/user-image.svg
// module id = 141
// module chunks = 0